module.exports = __webpack_public_path__ + "media/images/icons/outlined/tool-b5f5052df4a9fbcfb9cbdbba39e2b738.svg";